import { style } from "@vanilla-extract/css";
import { breakpoints } from "./breakpoints";
import { vars } from "./theme.css";
import { borderedCell, textTruncate } from "./utils.css";

export const stickyListHeader = style({
  position: "sticky",
  zIndex: vars.zIndex.table.stickyHead,
  top: 0,
  backgroundColor: vars.colors.surface,
  padding: `${vars.space.m} 0`,
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.s,
});

export const listTableBody = style({
  textAlign: "center",
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.s,
});

export const listTableElementColumn = style([
  stickyListHeader,
  {
    zIndex: vars.zIndex.table.firstStickyCol,
    insetInlineStart: 0,
    width: 190,
    "@media": {
      [`(min-width: ${breakpoints[2]})`]: {
        width: 275,
      },
    },
  },
]);

export const listTableStatColumn = style([
  stickyListHeader,
  {
    width: 50,
    color: vars.colors.onSurfaceVariant,
    fontSize: vars.fontSizes.body.s,
  },
]);

export const listTableFixtureColumn = style([
  stickyListHeader,
  {
    width: 60,
    color: vars.colors.onSurfaceVariant,
    fontSize: vars.fontSizes.body.s,
  },
]);

export const listTableWideColumn = style([
  stickyListHeader,
  {
    width: 130,
    whiteSpace: "normal",
    color: vars.colors.onSurfaceVariant,
    fontSize: vars.fontSizes.body.s,
  },
]);

export const listTableHeader = style({
  zIndex: vars.zIndex.table.stickyHead,
  backgroundColor: vars.colors.surface,
  padding: `${vars.space.xs} 0`,
  textAlign: "start",
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

const listTableStickyWrap = style({
  position: "sticky",
  zIndex: vars.zIndex.table.firstStickyCol,
  insetInlineStart: 0,
  display: "inline-block",
  backgroundColor: vars.colors.surface,
  width: "fit-content",
  textAlign: "start",
});

export const listTablePosition = style([
  listTableStickyWrap,
  {
    padding: `${vars.space.xs} ${vars.space.s}`,
    color: vars.colors.onSurface,
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.heading.m,
  },
]);

export const listTablePlaceholderButtonWrap = style([
  listTableStickyWrap,
  {
    padding: vars.space.s,
  },
]);

export const listTablePositionCell = style({
  textAlign: "start",
});

export const stickyListColumn = style({
  position: "sticky",
  zIndex: vars.zIndex.base,
  insetInlineStart: "0",
});

export const listTableRowStyles = style({
  borderBottom: vars.borders.outlineVariant,
  overflow: "auto",
  verticalAlign: "middle",
});

export const listTableElement = style([
  borderedCell,
  stickyListColumn,
  textTruncate,
  {
    backgroundColor: vars.colors.surface,
  },
]);

export const listTableElementWrap = style({
  display: "flex",
  alignItems: "center",
});

export const listTableCell = style({
  padding: ` 0 ${vars.space.xs}`,
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.s,
});

export const myTeamTableElement = style([
  stickyListColumn,
  textTruncate,
  borderedCell,
  {
    backgroundColor: vars.colors.surface,
  },
]);

export const priceChangeCell = style({
  borderRadius: vars.radii.xs,
  padding: "2px 4px",
  // Keep the signed percentage (e.g. +75%, -250%) LTR in RTL locales.
  direction: "ltr",
  unicodeBidi: "isolate",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});
